import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { CLIENT_ID, COGNITO_BASE_URL } from '../Cognito';
import { LoginHeroIllustration } from './Illustrations';

const Login: React.FC = () => {

  // build a base URL from the protocol, host, and port only
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const redirectUrl = `${baseUrl}/token`
  const loginUrl = `${COGNITO_BASE_URL}/login?client_id=${CLIENT_ID}&response_type=code&scope=openid%20email%20profile&redirect_uri=${encodeURIComponent(redirectUrl)}`

  return (
    <Box justifyContent="center" sx={{ p: 2 }}>
      <Stack justifyContent="center" alignItems="center" spacing={2} sx={{ mt: 8 }}>
        <LoginHeroIllustration />
        <Typography variant='h4' fontWeight={700}>stashsite</Typography>
        <Typography variant='body1' color='text.secondary'>A modern bookmarking app</Typography>
        <Button variant='contained' color='secondary' sx={{ px: 4, py: 1.25 }} href={loginUrl}>Sign in</Button>
      </Stack>
    </Box>
  );
};

export default Login;
